import { render, staticRenderFns } from "./HistoricoPedido.vue?vue&type=template&id=5bf03bbd"
import script from "./HistoricoPedido.vue?vue&type=script&lang=js"
export * from "./HistoricoPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports